import xhr from 'xhr.js';
import auth from 'services/auth';

const integrations = {
    createZoomToken: async code => {
        const account_id = auth.getAccountId();
        const res = await xhr.post(
            `/integrations/zoom/token?account_id=${account_id}`,
            {},
            {
                withCredentials: true,
                params: {
                    code
                }
            }
        );
        return res.data;
    },
    disconnectZoomAccount: async () => {
        const account_id = auth.getAccountId();
        const res = await xhr.post(
            `/integrations/zoom/disconnect?account_id=${account_id}`,
            {},
            {
                withCredentials: true
            }
        );
        return res.data;
    },
    disconnectCalendlyAccount: async () => {
        const account_id = auth.getAccountId();
        const res = await xhr.post(
            `/integrations/calendly/disconnect?account_id=${account_id}`,
            {},
            {
                withCredentials: true
            }
        );
        return res.data;
    },
    disconnectTremendousAccount: async () => {
        const account_id = auth.getAccountId();
        const res = await xhr.post(
            `/integrations/tremendous/disconnect?account_id=${account_id}`,
            {},
            {
                withCredentials: true
            }
        );
        return res.data;
    }
};

export default integrations;
